import { Typography } from "@mui/material";

const TextAreaWithCounter = ({
  value,
  onChange,
  readOnly = false,
  color = "#000",
}) => (
  <>
    <textarea
      style={{
        resize: "none",
        border: "1px solid #b8bdc9",
        borderRadius: "3px",
        padding: "10px",
        width: "100%",
        height: "163px",
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: 1.45,
        color,
        marginBottom: "8px",
      }}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
    />
    <Typography variant="subtitle1" color="#b8bdc9">
      {value.length}/400
    </Typography>
  </>
);

export default TextAreaWithCounter;
